export const emptyRule = () => ({
  effects: [],
  validation: [],
  optionFilter: null,
});

export function mergeRule(a, b) {
  return {
    effects:       [...(a.effects || []),    ...(b.effects || [])],
    validation:    [...(a.validation || []), ...(b.validation || [])],
    optionFilter:  b.optionFilter  ?? a.optionFilter,
    isNonEditable: b.isNonEditable ?? a.isNonEditable,
  };
}